import { CdkTableModule } from '@angular/cdk/table';
import { SortHeaderDirective } from './sort-header.directive';
import { SortDirective } from './sort.directive';
import { TableEmptyComponent } from './table-empty/table-empty.component';
import { TableDirective } from './table.directive';

export const TABLE_DIRECTIVES = [
  CdkTableModule,
  TableDirective,
  SortDirective,
  SortHeaderDirective,
  TableEmptyComponent,
] as const;

export { SortDirective, SortHeaderDirective, TableDirective, TableEmptyComponent };
export type { SortDirection, SortState } from './table.type';
